const zh = {
  aiNotice: {
    banner: "✨ 本网站的英文和中文版本由先进的人工智能（AI）技术自动翻译生成。",
    badge: "🤖 AI 智能翻译",
    dropdownNotice: "英文与中文翻译由人工智能（AI）模型驱动生成。",
    modalTitle: "AI 翻译说明",
    modalText: "为了便于全球访客和国际合作伙伴了解利皮克人工智能中心的课程与项目，英文和中文版本由先进的 AI 模型实时翻译转换。"
  },
  nav: {
    home: "首页",
    educations: "培训课程",
    programmerOnline: "人工智能程序员 - 线上班",
    programmerLive: "人工智能程序员 - 线下实地班",
    expertOnline: "人工智能高级专家 - 线上班",
    aboutUs: "关于我们",
    edih: "欧洲数字创新枢纽 (EDIH)",
    blog: "官方博客",
    inMedia: "媒体报道",
    contact: "联系我们",
    applyNow: "立即报名",
    applyProgrammerOnline: "线上程序员",
    applyProgrammerLive: "线下实地程序员",
    applyExpertOnline: "线上AI专家",
    languageSelect: "语言选择"
  },
  hero: {
    badge: "招生进行中",
    title: "人工智能程序员 - 线上班",
    learnMoreBtn: "了解详情并报名",
    feature1: "线上讲座与实战编码练习",
    feature2: "凭克罗地亚国家就业局 (HZZ) 代金券全额免费",
    feature3: "开课时间：2026年11月"
  },
  home: {
    programHeader: "线上精品课程 - 2026年11月",
    programTitle: "人工智能程序员 - 线上班",
    programDesc: "本项目旨在通过高强度、沉浸式的学习，使学员深刻掌握并灵活应用编程、数据科学、机器学习和深度学习的核心技术。学员将全面掌握 Python 编程，学习数据采集与分析，构建机器学习算法模型，训练与优化神经网络，并开发实际产业应用场景中的人工智能解决方案。",
    eligibility: "招生对象：",
    eligibilityText: "在职人员及待业求职者，须具备克罗地亚资格框架 (CROQF) 4.2 级或同等及以上高中/中专学历。",
    funding: "学费资助：",
    fundingText: "克罗地亚国家就业局 (HZZ) 代金券全额资助、企业雇主赞助或学员自费。",
    duration: "课程学制：",
    durationText: "6 至 9 个月（取决于授课进度与排课节奏）",
    start: "开班时间：",
    startText: "2026年11月",
    schedule: "授课时间：",
    scheduleText: "每周 3 次，线上授课，中欧时间 17:30 开始——专为在职人士量身定制",
    visits: "实地赴利皮克安排：",
    visitsText: "全程共 5 次周末赴利皮克中心（周五下午 / 周六实地工坊与交流）",
    ects: "修完全部课程并通过考核后，将授予 21 个 CSVET / ECTS 欧洲大学学分。",
    readMoreBtn: "查看详情并申请报名",
    blogSectionTitle: "博客最新文章",
    blogSectionSubtitle: "紧跟人工智能前沿动态、前沿洞察与实用技术指南",
    readMoreLink: "阅读全文 →",
    viewAllBlogsBtn: "浏览所有文章"
  },
  about: {
    header: "关于利皮克人工智能中心 (AI CENTER LIPIK)",
    title: "融汇历史底蕴、远大愿景与未来前沿科技",
    subtitle: "这座拥有悠久温泉历史与文化传统的斯拉沃尼亚小城，如何蜕变为克罗地亚最具影响力的人工智能教育、研发与创业孵化核心枢纽。",
    historyContext: "历史渊源与城市底蕴",
    historyTitle: "从皇家温泉疗养胜地到现代科技创新高地",
    historyP1: "利皮克是一座底蕴深厚的历史名城——以其延续百年的温泉疗养传统、富含矿物质的地热泉眼、国家级保护历史园林、宏伟的库尔沙隆（Kursalon）大厦以及闻名遐迩的利皮扎皇家马国家种马场享誉欧洲。",
    historyP2: "在经历战火重创后，利皮克人民以非凡的毅力重建了这座城市。在精心守护历史文脉与自然馈赠的同时，孕育出了一个宏伟的设想：通过发展世界最前沿的数字化与人工智能技术，为青年一代提供来到斯拉沃尼亚、扎根利皮克的全新契机。",
    captionKursalon: "百年历史园林与库尔沙隆大厦",
    captionLipizzaner: "闻名世界的利皮扎皇家马传统",
    foundingContext: "创立背景与战略愿景（2021年）",
    foundingTitle: "利皮克人工智能中心 (AI Center Lipik)",
    foundingP1: "2021年3月30日，利皮克人工智能中心（AI Center Lipik）由利皮克发展与旅游署（LIRA d.o.o.）正式揭牌创立。",
    foundingP2: "该项目的战略目标非常坚定：构建一个有机融合顶级技术教育、专家导师辅导、尖端研发环境及安居乐业扶持的创新生态，将利皮克打造为巴尔干及中欧地区备受瞩目的 AI 创新高地。",
    foundingQuote: "“我们的愿景纯粹而坚定：赋能广大学员掌握21世纪最核心的前沿技能，并为科技创业团队与初创公司提供茁壮成长的摇篮。”",
    captionBuilding: "利皮克人工智能中心大楼",
    captionJetracer: "学员在实践工坊中调优自主 AI 车辆模型",
    eduContext: "教育体系与卓越成果",
    eduTitle: "人工智能专业人才教育基地",
    eduSubtitle: "培训体系与波热加旅游与乡村发展学院深度学术共建，并获克罗地亚国家就业局 (HZZ) 代金券全额支持，为学员颁发正规高等教育 ECTS 学分及官方微专业资格证书。",
    card1Title: "前沿严谨的课程体系",
    card1Desc: "涵盖 Python 编程、数据科学、机器学习、深度学习、计算机视觉及自然语言处理，历经 600 至 900 课时的理论深潜与工程实践。",
    card2Title: "前沿硬件实操与自动驾驶",
    card2Desc: "学员在真实业务场景中演练算法，包括在 JetRacer 自动驾驶迷你小车平台上训练神经网络，以及处理复杂工业级数据集。",
    card3Title: "卓著的就业率与行业认可",
    card3Desc: "数以百计来自克罗地亚全境（从杜布罗夫尼克到奥西耶克）的学员在此完成蜕变，结业后在科技企业和软件行业享有极高的入职就业率。",
    captionClassroom: "交互式机房教学与团队协作攻关",
    captionGraduates: "顺利完成学业并获颁资格认证的结业学员",
    startupContext: "创业扶持与孵化生态（2022年）",
    startupTitle: "AI 创业孵化器与加速器",
    startupP1: "2022 年底，利皮克正式启用占地超过 400 平方米的现代 AI 创业孵化基地，内设独立工作室、共享工位、休闲解压区、高算力服务器机房和智能硬件实验室。",
    startupP2: "孵化器为初创科技企业提供全方位的支持体系：",
    startupLi1: "全套现代办公设施配置及高速千兆光纤网络支持",
    startupLi2: "由行业顶尖资深技术专家与架构师提供一对一创业指导",
    startupLi3: "利皮克市政府、省政府及就业局提供的启动资金支持",
    startupLi4: "针对青年科技人才及其家庭的住房安居落户与安家补贴",
    startupP3: "截至目前，已有超过 15 家创新型软件与科技企业在此成功孵化，面向克罗地亚本土及欧美海外市场开发高附加值数字化产品。",
    captionIncubatorBuilding: "利皮克 AI 创业孵化中心大厦",
    captionIncubatorOffice: "为入驻科技创业团队打造的现代化办公空间",
    partnerContext: "战略合作与生态联盟",
    partnerTitle: "携手实体经济与公共部门深化合作",
    finaTitle: "克罗地亚国家金融署 (FINA) 研发中心",
    finaDesc: "克罗地亚金融署（FINA）在利皮克中心设立了专门的 AI 研发分中心。常驻工程师与研究员专注于金融大数据分析算法、欺诈检测与下一代国家级金融智能系统的研发。",
    edihTitle: "欧洲数字创新枢纽 (AI & Gaming EDIH)",
    edihDesc: "利皮克是“AI & Gaming EDIH”的核心发起成员之一。作为欧盟委员会批准在克罗地亚仅设立的 4 个欧洲数字创新枢纽之一，我们为中小企业和公共机构提供免费的数字化转型升级全套赋能。",
    ctaTitle: "有意参加我们的培训或洽谈商务合作？",
    ctaDesc: "无论您是渴望掌握前沿的人工智能编程开发技能，还是希望将您的创新科技企业入驻孵化，我们的大门永远向您敞开。",
    ctaBtnEdu: "查看培训课程",
    ctaBtnContact: "立即联系我们"
  },
  programmerOnline: {
    header: "线上精品课程 - 2026年11月",
    title: "人工智能程序员 - 线上班",
    desc: "本项目经过精心架构，旨在通过高强度、结构化的线上学习，全面培养学员在编程语言、数据工程、机器学习与深度学习的核心竞争力。学员将从零系统掌握 Python 开发，进行数据清洗与特征工程，构建并评估经典机器学习与深度神经网络模型，解决实际产业分析与智能化业务难题。课程还深入涵盖计算机视觉领域的卷积神经网络与实际落地部署。",
    collab: "本项目与波热加旅游与乡村发展学院（Faculty of Tourism and Rural Development in Požega）联合办学。",
    start: "开班时间：2026年11月",
    schedule: "授课时间：每周 3 次，线上授课，中欧时间 17:30 开始——专为在职人员兼顾工作设计",
    visits: "实地赴利皮克安排：共 5 次周末实地到访（周五下午 / 周六线下集中演练与指导）",
    ects: "结业后授予 21 个正式 CSVET / ECTS 欧洲大学学分。",
    applyBtn: "立即报名申请",
    curriculumTitle: "培养方案与课程进度计划",
    eligible: "招生对象：",
    eligibleText: "在职员工及待业求职人员，需具备相当于克罗地亚资格框架 (CROQF) 4.2 级或以上的高中/中专及以上学历。学员具备基本的数学与逻辑思维能力及计算机操作常识即可；具有编程初级经验或数据处理基础者更佳。特别适合期望在人工智能领域进修深造、转行转岗或提升职场核心竞争力的学员。",
    funding: "学费资助：",
    fundingText: "克罗地亚国家就业局 (HZZ) 代金券全额免费资助、企业全额/部分资助或个人自费。",
    cert: "结业证书：",
    certText: "颁发官方认证的“机器学习与深度学习分析师（Analyst for Machine and Deep Learning）”微专业职业资质证书，并获得 21 个 ECTS 欧洲学分。",
    skills: "毕业所获核心能力与专业素养：",
    skillsText: "学员将系统掌握 Python 高级编程、核心数据结构与经典算法、数据采集清洗与预处理管线、监督学习与无监督学习原理、模型验证与超参数优化，以及深度神经网络的搭建与微调。能够独立将复杂的商业分析需求转化为工程代码，使用 Scikit-Learn、NumPy、Pandas、TensorFlow/PyTorch 进行全链路建模与调优，并向技术专家与管理层汇报分析结果。",
    curriculumHeader: "模块设置：",
    m1: "Python 编程基础与进阶 – 180 课时（50小时理论授课，70小时上机实验，60小时自主开发）",
    m2: "数据科学与统计分析导论 – 210 课时（50小时理论授课，90小时上机实验，70小时自主开发）",
    m3: "机器学习核心算法与应用 – 90 课时（20小时理论授课，40小时上机实验，30小时自主开发）",
    m4: "深度学习与计算机视觉实践 – 150 课时（40小时理论授课，60小时上机实验，50小时自主开发）",
    totalHours: "总计：630 课时（160小时授课，260小时实验，210小时自主项目演练）– 21 ECTS 学分",
    duration: "培训学制：",
    durationText: "6 至 9 个月，视具体教学排课安排及学员进度而定。",
    startDetail: "开班时间：2026年11月",
    scheduleDetail: "上课时间：每周 3 次，线上授课，中欧时间 17:30 开始。",
    visitsDetail: "实地赴校：共 5 次周末赴利皮克中心现场实操授课（周五下午及周六上午）。",
    location: "授课形式：",
    locationText: "全程以线上交互直播与在线辅导为主，结合 5 次在利皮克人工智能中心举行的周末线下实训。",
    otherWaysTitle: "其他报名联络渠道",
    otherWaysSubtitle: "除在线表单外，您还可以通过以下方式向我们递交申请：",
    byEmail: "电子邮件：",
    byEmailText: "发送邮件至 gabrijela.mijatovic@lipik.ai，注明您的姓名、电子邮箱及联系电话。我们的教务团队将协助您完成后续注册流程。",
    byPhone: "电话咨询：",
    byPhoneText: "致电 +385 (0)99 3808 436（联系人：Gabrijela）。",
    inPerson: "现场到访：",
    inPersonText: "欢迎亲临利皮克人工智能中心，地址：Hrvatske mladeži 32, 34551 Lipik, Croatia。接待时间：周一至周五 07:00 - 15:00（中欧时间）。"
  },
  programmerLive: {
    header: "利皮克现场面授班 - 2027年春季",
    title: "人工智能程序员 - 线下实地班",
    desc: "沉浸式现场全日制/兼读制教学，让学员身临其境地在利皮克人工智能中心与资深导师面对面切磋，深入理解并运用现代软件工程、数据科学、机器学习与自主智能系统的前沿技术，亲手操作真实边缘计算硬件与智能机器人。",
    collab: "与波热加旅游与乡村发展学院（Faculty of Tourism and Rural Development in Požega）联合办学。",
    start: "开班时间：2027年春季",
    lectures: "理论授课：每周五下午及周六全天在利皮克现场集中面授",
    exercises: "实验辅导：每周安排一次周中线上答疑与编码作业检查",
    ects: "结业后授予 21 个正式 CSVET / ECTS 欧洲大学学分。",
    durationText: "6 个月。",
    locationText: "主要理论教学与阶段考核在利皮克人工智能中心大厦现场举行，实验指导通过专属线上系统进行配合。"
  },
  expertOnline: {
    header: "线上高级进阶班 - 2027年春季",
    title: "人工智能高级专家 - 线上班",
    desc: "这是一门面向具备大学或专科以上学历专业人才的高阶课程。系统培训学员独立构思与研发完整 AI 架构、采集复杂非结构化数据、设计定制化深度神经网络，以及落地计算机视觉和自然语言处理 (NLP) 尖端解决方案的能力。",
    collab: "与波热加旅游与乡村发展学院（Faculty of Tourism and Rural Development in Požega）联合办学",
    start: "新一期开班时间：2027年春季",
    ects: "结业授予 30 个正式 CSVET / ECTS 欧洲大学学分。",
    eligibleText: "在职专业技术人员或待业毕业生，须至少具备高等专科或大学本科学位。",
    certText: "颁发“人工智能专家（Artificial Intelligence Specialist）”高级微专业认证证书，计 30 个 ECTS 学分。",
    fundingText: "支持克罗地亚国家就业局 (HZZ) 代金券全额免费申请、企业人才赞助或自费报读。",
    skillsText: "熟练精通 Python 高阶架构设计、端到端机器学习流程开发、自定义损失函数与优化器设计、经典与最新深度学习架构（Transformer、CNN、GAN 等）、图像分割与目标检测、自然语言理解与大语言模型应用部署。",
    m1: "Python 高级工程化编程 – 150 课时（40讲座，60实验，50自研）",
    m2: "机器学习算法设计与调优 – 150 课时（40讲座，60实验，50自研）",
    m3: "深度学习与神经网络架构 – 240 课时（70讲座，90实验，80自研）",
    m4: "计算机视觉与图像处理 – 120 课时（30讲座，50实验，40自研）",
    m5: "数据科学与大数据分析技术 – 150 课时（40讲座，60实验，50自研）",
    m6: "自然语言处理 (NLP) 与大模型前沿 – 90 课时（20讲座，40实验，30自研）",
    totalHours: "总计：900 课时（240小时讲座，360小时实验，300小时毕业综合项目设计）– 30 ECTS 学分",
    scheduleTerms: "课时周期安排：",
    term1: "每周 2 至 3 次线上互动直播教学（每次 4 课时，安排在下午/傍晚，每月提前下发具体排课表），",
    term2: "全年总计 6 次赴利皮克现场集中面授（每个主要模块结课后），周五下午举办大师强化讲座，周六上午进行实操成果验收评估。",
    durationText: "12 个月（600课时直播讲授与实验辅导 + 300课时导师指导下的独立毕业项目设计）"
  },
  edih: {
    header: "欧洲数字创新枢纽 (EDIH)",
    title: "AI & GAMING (JURK) EDIH",
    desc: "AI & GAMING (JURK) EDIH 作为一站式数字化赋能平台，面向克罗地亚中部及北亚得里亚海地区的中小微企业 (SME) 和公共管理机构提供全流程数字化转型服务。EDIH 依托在人工智能 (AI)、游戏化 (Gamification) 和区块链 (Blockchain) 领域的深厚技术积淀，助力机构快速引入尖端数字生产力。",
    subDesc: "全面赋能中小企业与公共部门的数字化转型升级",
    contactBtn: "咨询联系我们",
    servicesTitle: "服务项目",
    servicesIntro: "EDIH 的所有赋能服务均旨在推动产业与政务数字化变革，对符合资格的受惠企业和机构完全免费！涵盖的主要服务包括：",
    s1: "企业数字成熟度评估诊断",
    s2: "创新科技项目与商业化转化全流程支持",
    s3: "投资前技术验证 (Test Before Invest)",
    s4: "数字孪生 (Digital Twin) 系统开发与仿真",
    s5: "专业赋能培训（数字商务技能、游戏化、区块链、物联网、高强度训练营）",
    s6: "7x24小时微软在线认证培训与技能赋能平台",
    s7: "医疗健康与康复领域数字化创新赋能",
    s8: "商业战略与前沿技术综合咨询顾问",
    s9: "项目路演辅导与众筹融资准备",
    s10: "对接风险投资机构与拓展融资渠道",
    s11: "与全欧其他欧盟 EDIH 创新枢纽协同联动",
    consortiumTitle: "共建联盟机构",
    consortiumIntro: "数字化推进工作由 8 家顶尖政产学研机构组成的战略联盟协同执行：",
    c1: "锡萨克-莫斯拉维纳省区域协调发展公共机构",
    c2: "SIMORA 发展署 – PISMO 游戏产业孵化器",
    c3: "萨格勒布大学物理研究所",
    c4: "萨格勒布大学组织与信息学院 (FOI)",
    c5: "里耶卡 PAR 高等商学院",
    c6: "利皮克人工智能中心 - LIRA 发展署",
    c7: "HashNET 有限责任公司",
    c8: "FAST LANE 有限责任公司",
    focusTitle: "重点赋能领域",
    focusIntro: "数字化转型服务广泛覆盖实体产业，并重点深耕以下战略领域：",
    f1: "电子游戏与互动娱乐开发",
    f2: "智慧农业与自动驾驶装备",
    f3: "文化旅游与数字文旅",
    f4: "智慧医疗与康复康养",
    f5: "现代林木加工与家具制造",
    f6: "绿色智慧建筑与基础设施",
    f7: "生物医药与健康产业",
    f8: "高等教育与教育科技",
    aboutProjectTitle: "关于本项目",
    aboutP1: "AI & GAMING EDIH 项目总投资 230 万欧元，由欧盟委员会“数字欧洲计划（DIGITAL EUROPE）”与克罗地亚国家复苏与韧性计划（NPOO 2021-2026）联合资助，于 2022 年 12 月 1 日正式启动运行。",
    aboutP2: "本项目入选欧盟首批 151 个欧洲数字创新枢纽网络名录，也是克罗地亚全国仅有的 4 个国家级创新枢纽之一。"
  },
  blog: {
    header: "官方博客",
    subtitle: "追踪人工智能前沿趋势、行业洞察与实用技术深度解析。",
    readMore: "阅读全文",
    backToBlog: "← 返回博客列表",
    author: "作者：",
    date: "日期：",
    notFound: "未找到该博客文章。",
    interestedTitle: "对我们的人工智能培训感兴趣？",
    programOnlineBtn: "线上程序员班",
    programLiveBtn: "线下实地面授班",
    expertOnlineBtn: "线上高级专家班"
  },
  media: {
    header: "媒体报道与新闻专访",
    title: "主流媒体眼中的利皮克人工智能中心",
    subtitle: "查阅克罗地亚国家级主流媒体与地方权威报刊对我们的 AI 课程、学员故事、创业孵化器及科技成果的深度报道。",
    all: "全部报道",
    national: "国家级媒体",
    local: "地方媒体",
    business: "商业财经",
    video: "电视与视频专访",
    sortNewest: "最新优先",
    sortOldest: "最早优先",
    readFullArticle: "前往原媒体阅读完整报道：",
    noArticles: "在当前筛选条件下暂无报道。"
  },
  contact: {
    title: "联系我们",
    subtitle: "如有任何疑问，欢迎通过电子邮件、电话咨询或亲临我们在利皮克的园区。",
    addressTitle: "办公地址：",
    address: "Centar umjetne inteligencije Lipik\nHrvatske mladeži 32\n34551 Lipik, Croatia (克罗地亚)",
    phoneTitle: "联系电话：",
    phone: "移动电话：+385 (0)99 3808 436（联系人：Gabrijela）",
    emailTitle: "官方邮箱：",
    email: "gabrijela.mijatovic@lipik.ai",
    hoursTitle: "工作时间：",
    hours: "周一至周五：07:00 - 15:00（中欧时间）",
    mapTitle: "利皮克人工智能中心地理位置"
  },
  form: {
    title: "立即申请报名",
    subtitleSingle: "请填写下方申请表格，即可为您预留课程名额。",
    subtitleMulti: "请填写下方申请表格，即可为您预留我们培训课程的名额。",
    successAlert: "您的报名信息已成功提交！感谢您的关注与信任，我们将尽快与您取得联系。",
    errorAlert: "提交报名时发生错误，请检查您的联系方式并重试。",
    captchaError: "数学人机验证答案错误，请重新核对计算。",
    selectProgramLabel: "请选择意向课程",
    selectProgramPlaceholder: "请选择您希望报读的人工智能培训项目",
    prog1: "人工智能程序员 - 线上班",
    prog2: "人工智能程序员 - 线下实地班",
    prog3: "人工智能高级专家 - 线上班",
    nameLabel: "姓名",
    namePlaceholder: "请输入您的真实姓名",
    emailLabel: "电子邮箱",
    emailPlaceholder: "your@email.com",
    phoneLabel: "手机电话号码",
    phonePlaceholder: "+385 9x xxx xxxx 或国际格式",
    educationLabel: "最高学历层次",
    educationPlaceholder: "请选择您的最高受教育程度",
    eduSSS: "中等职业教育 / 高中毕业 (SSS)",
    eduVSS1: "大学专科 / 高等职业技术教育 (VŠS)",
    eduVSS2: "大学本科 / 硕士 / 博士学位 (VSS)",
    messageLabel: "求学动机或疑问咨询（选填）",
    messagePlaceholder: "请简述您报读本项目的理由，或留下您想向导师咨询的问题",
    captchaLabel: "人机验证（确认您不是机器人）：",
    captchaPlaceholder: "请输入计算结果",
    gdprLabel: "本人知悉并同意利皮克人工智能中心根据欧盟《通用数据保护条例》(GDPR) 收集并处理上述个人信息，用于入学申请与教务联络。",
    submitBtn: "提交报名申请",
    submittingBtn: "正在发送提交..."
  },
  privacy: {
    title: "隐私权与个人信息保护声明",
    subtitle: "保障您的隐私与个人信息安全是我们坚守的准则。",
    p1: "利皮克人工智能中心（Centar umjetne inteligencije Lipik）通过在线报名表单收集并处理学员个人信息，此数据仅用于教育项目报名审查、录取管理及教务联络沟通。",
    p2: "在报名登记阶段，我们可能收集必要的联系信息和学历背景资料，包括学员姓名、电子邮箱、手机电话号码，以及与最高学历证明或克罗地亚国家就业局（HZZ）教育代金券申请相关的信息。",
    p3: "在后续正式入学注册过程中，我们可能会依法要求学员补充提供主管部门和合作高校审核所需的附加学籍证明材料。",
    p4: "所收集的全部个人信息仅供利皮克人工智能中心内部处理课程报名、联络学员及寄送相关教学通知之用，绝不会向未经授权的第三方出售或泄露。",
    p5: "通过报名表单提交个人信息即表明您已阅读、理解并同意本《个人信息保护声明》，并授权利皮克人工智能中心在上述合理合规范围内处理您的信息。",
    cookiesTitle: "Cookie 政策",
    cookiesText: "本网站使用 Cookie 技术来改善用户浏览体验并保障网站基础功能正常运转。继续浏览本网站即表示您同意我们使用 Cookie。",
    contactTitle: "隐私与数据合规联系方式",
    contactText: "如对您的个人信息处理有任何疑问、异议或需要申请修改注销，请随时联络：",
    email: "官方邮箱：",
    address: "办公地址：Centar umjetne inteligencije Lipik, Hrvatske mladeži 32, 34551 Lipik, Croatia"
  },
  footer: {
    companyName: "利皮克人工智能中心 (AI CENTER LIPIK)",
    companyAgency: "Lipička razvojna i turistička agencija Lipik d.o.o.",
    companyAddress: "Hrvatske mladeži 32, 34551 Lipik, Croatia",
    companyOib: "税号 (OIB): 54639446953",
    navHeader: "培训项目与课程",
    progOnline: "人工智能程序员 - 线上班",
    progLive: "人工智能程序员 - 线下实地班",
    progExpert: "人工智能高级专家 - 线上班",
    inMedia: "媒体视野中的中心",
    contactHeader: "联系咨询",
    phone: "手机 | +385 (0)99 3808 436（联系人：Gabrijela）",
    email: "邮箱 | gabrijela.mijatovic@lipik.ai",
    privacyLink: "隐私权与个人信息保护政策",
    allRightsReserved: "版权所有，保留一切权利。",
    backToTop: "返回顶部",
    aiDisclaimer: "本网站英文及中文版本由人工智能 (AI) 辅助翻译生成。"
  },
  cookies: {
    text: "本网站使用 Cookie 以确保为您提供最佳的浏览体验。继续访问即表示您同意我们使用 Cookie。如需了解更多详情，请参阅我们的",
    privacyLink: "隐私政策",
    acceptBtn: "我同意"
  },
  accessibility: {
    title: "无障碍访问辅助",
    increaseFont: "A+ 放大字号",
    decreaseFont: "A- 缩小字号",
    contrast: "高对比度模式",
    dyslexic: "读写障碍关怀字体",
    underline: "下划线突出链接",
    reset: "恢复默认设置"
  },
  admin: {
    title: "后台管理",
    subtitle: "请输入访问密码以查看学员报名记录。",
    codePlaceholder: "访问密钥",
    submitBtn: "进入后台",
    wrongCode: "访问密钥错误！",
    tableTitle: "学员报名申请明细",
    exportBtn: "导出为 Excel (.csv)",
    loading: "正在加载报名数据...",
    noData: "当前暂无报名的学员数据。",
    thDate: "提交日期",
    thName: "姓名",
    thEmail: "电子邮箱",
    thPhone: "联系电话",
    thProgram: "报读课程"
  }
};

export default zh;
